import toast from 'react-hot-toast'

import {
  buildFetchOptionsWithAuth,
  fetchJson,
  showApiError,
  useMutation,
  useQueryClient,
} from '@fv/client-core'
import type {
  LegacyHandlingUnitDTO,
  ProductCatalogEntry,
} from '@fv/client-types'

import { apiUri } from '@/constants'

import { buildLegacyHandlingUnitDTO } from './commodityUtils'
import { handlingUnitKeys } from './useHandlingUnits'

async function createHandlingUnit(
  product: ProductCatalogEntry,
): Promise<LegacyHandlingUnitDTO> {
  const handlingUnit = buildLegacyHandlingUnitDTO(product)
  const endpoint = `${apiUri}/handling-units`
  const options = buildFetchOptionsWithAuth({
    body: JSON.stringify(handlingUnit),
    method: 'POST',
  })

  const response = await fetchJson(endpoint, options)
  if (response.ok) return response.json
  throw response.errorMessage
}

export function useCreateHandlingUnit() {
  const queryClient = useQueryClient()

  return useMutation(createHandlingUnit, {
    onSettled: (handlingUnit, error) => {
      if (error) return showApiError('Unable to add product', error)

      if (handlingUnit) {
        queryClient.setQueryData(
          handlingUnitKeys.id(handlingUnit._id),
          handlingUnit,
        )
      }

      const queryKey = handlingUnitKeys.filter({ mode: handlingUnit?.mode })
      setTimeout(() => {
        // TODO is there a better way to optimistically update paged/searchable data
        queryClient.invalidateQueries({ queryKey: queryKey })
      }, 2000)
      toast.success('Product added successfully.')
    },
  })
}
